import { Link } from 'gatsby'
import styled from 'styled-components'

export const MenuPanelContainer = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 49px);
  top: 49px;
  left: 0;
  transform: translateX(${({ open }) => (open ? '0' : '-100%') });
  transition: 0.5s transform;
  background: white;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  @media (min-width: 768px) {
    display: none;
  }
`

export const NoUnderlineLink = styled(Link)`
  text-decoration: none;
  text-transform: uppercase;
  color: black;
  font-family: VerlagBold;
  font-size: 1.8rem;
  letter-spacing: 0.15rem;
  margin: 2rem 0;
`

export const MushroomImage = styled.img`
  width: 32px;
  margin: 2rem 0;
`
